
$(window).on('load',function (){
  
        let textToChangeEl = document.querySelector(".discount-label");
        if (textToChangeEl) {
            // Apply the replacements
            $(textToChangeEl).text($(textToChangeEl).text().replace("5.87%", ""));
            $(textToChangeEl).text($(textToChangeEl).text().replace("4.54%", ""));
            $(textToChangeEl).text($(textToChangeEl).text().replace("7.13%", ""));
    }
  $(".subscription-radio .discount-label").css("opacity", "1");

});

    
